import styled from "styled-components";
import Theme from "../../Styles/Themes";
import config from '../../Config/config.json';
import SVG from "react-inlinesvg";
import { Calendar } from "../../Assets/icons";
import InputMask from 'react-input-mask';

export const Container = styled.div`
    align-items: ${props => props.$aling ? props.$aling : 'center'};
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: ${props => props.$width ? props.$width : '100%'};
`;

export const ContainerInput = styled.div`
    align-items: center;
    border:  ${props => props.$isvalid ? '2px solid'+props.$borderColor : '2px solid #FF3939'};
    border-radius: 10px;
    display: flex;
    justify-content: center;
    padding: 2px 12px 2px 12px;
    width: 100%;
`;

export const TextInput = styled(InputMask)`
    background: transparent;
    border: none;
    color: #006560;
    display: flex;
    font-size: ${Theme[config.theme].font.labels['small'].size};
    font-style: normal;
    font-weight: 400;
    line-height: ${Theme[config.theme].font.labels[config.fontSize].line_height};
    outline: none;
    padding: 10px 8px 10px 15px;
    width: 100%;

    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    &{
        -moz-appearance: textfield;
    }

    &::-webkit-calendar-picker-indicator{
        background-image: url(${Calendar});
        color: #333;
        cursor: pointer;
        fill: #333;
        height: 25px;
        text-decoration: none;
        width: 25px;
    }
    @media (min-width: 720px) {
        font-size: ${Theme[config.theme].font.labels[config.fontSize].size};
        padding: 17px 12px 19px 24px;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        font-size: ${Theme[config.theme].font.labels['small'].size};
        padding: 10px;
    }
`;

export const InvalidText = styled.label`
    color: #FF3939;
    display: flex;
    font-size: ${Theme[config.theme].font.paragraphs[config.fontSize].size};
    font-weight: ${Theme[config.theme].font.paragraphs[config.fontSize].weight};
    line-height: ${Theme[config.theme].font.paragraphs[config.fontSize].line_height};
    visibility: ${props => props.$visibility? 'hidden' : 'visible'};
    width: 88%;
`;

export const ImageIcons = styled(SVG)`
    height: 24px;
    width: 24px;
    & path {
        fill: ${({ color }) => color};
    }
`;